// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/
/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
*:not(dialog) {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  height: 100%;
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

img {
  width: 2rem;
  height: auto;
}

body {
  height: 90vh;
  overflow: hidden;
  display: flex;
  margin-top: 4rem;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  padding-bottom: 4rem;
}

.header {
  justify-content: center;
  /* width: 50%; */
  /* height: 4rem; */
  /* box-sizing: border-box; */
  display: flex;
  gap: 4rem;
}

.header p {
  font-weight: 800;
  font-size: 1.5rem;
}

.game-zone {
  /* margin-top: -5rem; */
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.gameboard-1,
.gameboard-2 {
  box-sizing: content-box;
  display: flex;
  flex-wrap: wrap;
  width: 20rem;
  height: 20rem;
  border: black 2px solid;
}
.cell {
  border: black 2px solid;
  box-sizing: border-box;
  width: 10%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ship {
  /* margin: auto; */
  /* margin-bottom: auto; */
  width: 80%;
  height: 80%;
}
.ship-unhit {
  background-color: greenyellow;
}
.ship-hit {
  background-color: red;
}
.missed {
  background-color: rgb(0, 229, 255);
}
.unseen {
  background-color: transparent;
}
.gameboard-1 {
  grid-area: gameboard-1;
}

.gameboard-2 {
  grid-area: gameboard-2;
}

#place-ships {
  grid-area: place-ships;
}

p.computer {
  text-align: center;
  grid-area: computer;
  font-weight: bold;
  font-size: 1.2rem;
}

p.player {
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  grid-area: player;
}

.boards {
  /* justify-self: center; */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, max-content));

  grid-template-areas:
    "player computer"
    "gameboard-1 gameboard-2"
    "place-ships .";

  gap: 1.5rem;
  /* margin-bottom: -2rem; */
}

button {
  height: auto;
  border-radius: 0.2rem;
  box-sizing: border-box;
  padding: 0.4rem;
  font-weight: bold;
  cursor: pointer;
}
#restart {
  position: absolute;
  top: 3.5rem;
  left: 56rem;
  /* margin-left: 12rem; */
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+DAA+D;;EAE/D;;;mBAGiB;;EAEjB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":["/*\r\n  Josh's Custom CSS Reset\r\n  https://www.joshwcomeau.com/css/custom-css-reset/\r\n*/\r\n/* 1. Use a more-intuitive box-sizing model */\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* 2. Remove default margin */\r\n*:not(dialog) {\r\n  margin: 0;\r\n}\r\n\r\n/* 3. Enable keyword animations */\r\n@media (prefers-reduced-motion: no-preference) {\r\n  html {\r\n    interpolate-size: allow-keywords;\r\n  }\r\n}\r\n\r\nbody {\r\n  height: 100%;\r\n  /* 4. Add accessible line-height */\r\n  line-height: 1.5;\r\n  /* 5. Improve text rendering */\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n/* 6. Improve media defaults */\r\nimg,\r\npicture,\r\nvideo,\r\ncanvas,\r\nsvg {\r\n  display: block;\r\n  max-width: 100%;\r\n}\r\n\r\n/* 7. Inherit fonts for form controls */\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n/* 8. Avoid text overflows */\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* 9. Improve line wrapping */\r\np {\r\n  text-wrap: pretty;\r\n}\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  text-wrap: balance;\r\n}\r\n\r\n/*\r\n  10. Create a root stacking context\r\n*/\r\n#root,\r\n#__next {\r\n  isolation: isolate;\r\n}\r\n\r\nimg {\r\n  width: 2rem;\r\n  height: auto;\r\n}\r\n\r\nbody {\r\n  height: 90vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  margin-top: 4rem;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n  justify-content: center;\r\n  padding-bottom: 4rem;\r\n}\r\n\r\n.header {\r\n  justify-content: center;\r\n  /* width: 50%; */\r\n  /* height: 4rem; */\r\n  /* box-sizing: border-box; */\r\n  display: flex;\r\n  gap: 4rem;\r\n}\r\n\r\n.header p {\r\n  font-weight: 800;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.game-zone {\r\n  /* margin-top: -5rem; */\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n.gameboard-1,\r\n.gameboard-2 {\r\n  box-sizing: content-box;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 20rem;\r\n  height: 20rem;\r\n  border: black 2px solid;\r\n}\r\n.cell {\r\n  border: black 2px solid;\r\n  box-sizing: border-box;\r\n  width: 10%;\r\n  height: 10%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.ship {\r\n  /* margin: auto; */\r\n  /* margin-bottom: auto; */\r\n  width: 80%;\r\n  height: 80%;\r\n}\r\n.ship-unhit {\r\n  background-color: greenyellow;\r\n}\r\n.ship-hit {\r\n  background-color: red;\r\n}\r\n.missed {\r\n  background-color: rgb(0, 229, 255);\r\n}\r\n.unseen {\r\n  background-color: transparent;\r\n}\r\n.gameboard-1 {\r\n  grid-area: gameboard-1;\r\n}\r\n\r\n.gameboard-2 {\r\n  grid-area: gameboard-2;\r\n}\r\n\r\n#place-ships {\r\n  grid-area: place-ships;\r\n}\r\n\r\np.computer {\r\n  text-align: center;\r\n  grid-area: computer;\r\n  font-weight: bold;\r\n  font-size: 1.2rem;\r\n}\r\n\r\np.player {\r\n  text-align: center;\r\n  font-weight: bold;\r\n  font-size: 1.2rem;\r\n  grid-area: player;\r\n}\r\n\r\n.boards {\r\n  /* justify-self: center; */\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(0, max-content));\r\n\r\n  grid-template-areas:\r\n    \"player computer\"\r\n    \"gameboard-1 gameboard-2\"\r\n    \"place-ships .\";\r\n\r\n  gap: 1.5rem;\r\n  /* margin-bottom: -2rem; */\r\n}\r\n\r\nbutton {\r\n  height: auto;\r\n  border-radius: 0.2rem;\r\n  box-sizing: border-box;\r\n  padding: 0.4rem;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n#restart {\r\n  position: absolute;\r\n  top: 3.5rem;\r\n  left: 56rem;\r\n  /* margin-left: 12rem; */\r\n  width: fit-content;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
